import { handleActions } from "redux-actions";
import { SHIPPING_CARRIER_SERVICES_COMPLETE, SHIPPING_CARRIER_SERVICES_REQUEST } from "constants/action-types";

interface IState {
    error?: boolean;
    isFetching: boolean;
    results: string[];
}

const initialState: IState = {
    error: undefined,
    isFetching: false,
    results: [],
};

export const shippingCarrierServices = handleActions(
    {
        [SHIPPING_CARRIER_SERVICES_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [SHIPPING_CARRIER_SERVICES_COMPLETE]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    error: true,
                    isFetching: false,
                };
            }

            return {
                ...state,
                error,
                isFetching: false,
                results: state.results.length ? (state.results.concat(payload) as string[]) : payload,
            };
        },
    },
    initialState
);
